export const GET_TIMESLOTS_FROM_STATE =
  '[Laboratory/getter] GET_TIMESLOTS_FROM_STATE'
export const GET_TIMESLOTS_STATISTIC_FROM_STATE =
  '[Laboratory/getter] GET_TIMESLOTS_STATISTIC_FROM_STATE'
export const GET_IS_LOADING_TIMESLOTS =
  '[Laboratory/getter] GET_IS_LOADING_TIMESLOTS'
export const GET_TIMESLOTS_PAGINATION =
  '[Laboratory/getter] GET_TIMESLOTS_PAGINATION'
export const GET_TIMESLOTS_CURRENT_STEP =
  '[Laboratory/getter] GET_TIMESLOTS_CURRENT_STEP'
export const GET_TERMINAL_QUOTA_FILTER =
  '[Laboratory/getter] GET_TERMINAL_QUOTA_FILTER'
export const GET_ACTIVE_TABLE_COLUMN =
  '[Laboratory/getter] GET_ACTIVE_TABLE_COLUMN'
export const FETCH_TIMESLOTS = '[Laboratory/action] FETCH_TIMESLOTS'
export const CHANGE_TIMESLOTS_REQUEST_FILTER_PARAMS =
  '[Laboratory/action] CHANGE_TIMESLOTS_REQUEST_FILTER_PARAMS'
export const CHANGE_TIMESLOTS_REQUEST_SORT_PARAMS =
  '[Laboratory/action] CHANGE_TIMESLOTS_REQUEST_SORT_PARAMS'
export const CHANGE_TIMESLOTS_PAGINATION_PER_PAGE =
  '[Laboratory/action] CHANGE_TIMESLOTS_PAGINATION_PER_PAGE'
export const CHANGE_TIMESLOTS_PAGINATION_NEW_PAGE =
  '[Laboratory/action] CHANGE_TIMESLOTS_PAGINATION_NEW_PAGE'
export const SET_IS_LOADING_TIMESLOTS =
  '[Laboratory/mutation] SET_IS_LOADING_TIMESLOTS'
export const SET_TIMESLOTS = '[Laboratory/mutation] SET_TIMESLOTS'
export const SET_TIMESLOTS_STATISTICS =
  '[Laboratory/mutation] SET_TIMESLOTS_STATISTICS'
export const SET_TIMESLOTS_PAGINATION =
  '[Laboratory/mutation] SET_TIMESLOTS_PAGINATION'
export const SET_ACTIVE_TABLE_COLUMN_ACTION =
  '[Laboratory/mutation] SET_ACTIVE_TABLE_COLUMN_ACTION'

export const SET_TIMESLOTS_REQUEST_FILTER_PARAMS =
  '[Laboratory/mutation] SET_TIMESLOTS_REQUEST_FILTER_PARAMS'
export const SET_TIMESLOTS_QUOTA_FILTER =
  '[Laboratory/mutation] SET_TIMESLOTS_QUOTA_FILTER'
export const SET_TIMESLOTS_REQUEST_SORT_PARAMS =
  '[Laboratory/mutation] SET_TIMESLOTS_REQUEST_SORT_PARAMS'
export const SET_TIMESLOTS_PAGINATION_PER_PAGE =
  '[Laboratory/mutation] SET_TIMESLOTS_PAGINATION_PER_PAGE'
export const SET_TIMESLOTS_PAGINATION_CURRENT_PAGE =
  '[Laboratory/mutation] SET_TIMESLOTS_PAGINATION_CURRENT_PAGE'
export const SET_ACTIVE_TABLE_COLUMN_MUTATION =
  '[Laboratory/mutation] SET_ACTIVE_TABLE_COLUMN_MUTATION'
export const SET_TIMESLOT_CURRENT_STEP =
  '[Laboratory/mutation] SET_TIMESLOT_CURRENT_STEP'
